import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { AUTH_USER } from './constants';
import {
  AuthUserDataActionTypes,
  IAuthUserError,
  IAuthUserState,
  IAuthUserSuccess,
} from './types';

const initialState: IAuthUserState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (draft = initialState, action: AuthUserDataActionTypes): IAuthUserState => {
    switch (action.type) {
      case AUTH_USER + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case AUTH_USER + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as IAuthUserSuccess).payload;
        break;
      }
      case AUTH_USER + FAILURE: {
        draft.status = rejected;
        draft.error = (action as IAuthUserError).error;
        break;
      }
      case AUTH_USER + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
